import i18n from "i18next";
// import XHR from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-locize-backend";
import moment from "moment";

const isBrowser = typeof window !== "undefined";

// Fallback resources for SSR to prevent missing key errors
const fallbackResources = {
  de: {
    translation: {
      // Add any critical translations needed during SSR
    }
  },
  en: {
    translation: {
      // Add any critical translations needed during SSR
    }
  }
};

// Base i18n configuration
const baseConfig = {
  fallbackLng: "de",
  debug: false,
  keySeparator: ">",
  nsSeparator: "|",
  interpolation: {
    escapeValue: false,
  },
  resources: fallbackResources,
  react: {
    useSuspense: false, // Disable suspense for SSR compatibility
  },
};

// Browser-specific configuration
if (isBrowser) {
  // Add browser-specific plugins and detection only in browser
  baseConfig.detection = {
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "navigator",
      "htmlTag",
      "path",
      "subdomain",
    ],
  };
  
  i18n
    .use(LanguageDetector)
    .use(Backend);
}

// Initialize i18n
i18n.init({
  ...baseConfig,
  ...(isBrowser && {
    backend: {
      projectId: "2b2f43c9-b1f9-4c37-bec0-1b1add4fbd00",
      apiKey: "ae4a785a-6e32-42b1-b67e-a25c73eef93d",
      referenceLng: "en",
    },
  }),
});

// Set moment locale based on i18n language
i18n.on("languageChanged", function (lng) {
  if (isBrowser) {
    moment.locale(lng);
  }
});

export default i18n;
